import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { siteSpecificData } from '../../../environments/site-specific-data';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class VersionService {

  getApplicationVersion(): Observable<string> {
    const versionNumberUrl = `${API_URL}application/displayversion`;
    const options: Object = {headers: Headers, responseType: 'text'};
    return this
      .http
      .get<string>(versionNumberUrl, options)
      .pipe();
  }

  constructor(private http: HttpClient) {
  }
}
